import {
  IsNumber,
  IsOptional,
  IsString,
  IsUUID,
  IsArray,
  MaxLength,
  Min,
  Max,
  IsEnum,
} from 'class-validator'
import { ApiPropertyOptional } from '@nestjs/swagger'
import { Transform } from 'class-transformer'
import {
  PedagogicContentState,
  ContentVisibility,
} from '../../../enums/content.enum'
import {
  MAX_LESSON_TITLE_LENGTH,
  MAX_LESSON_DESCRIPTION_LENGTH,
  MIN_LESSON_DURATION,
  MAX_LESSON_DURATION,
} from '../../../constants/lesson.constants'

const toNumber = ({ value }: { value: any }) => {
  if (value === '' || value === null || value === undefined) return undefined
  const num = Number(value)
  return isNaN(num) ? value : num
}

export class UpdateLessonDto {
  @ApiPropertyOptional({
    description: 'Titre de la leçon',
    maxLength: MAX_LESSON_TITLE_LENGTH,
    type: 'string',
  })
  @IsOptional()
  @IsString()
  @MaxLength(MAX_LESSON_TITLE_LENGTH)
  title?: string

  @ApiPropertyOptional({
    description: 'Description détaillée de la leçon',
    maxLength: MAX_LESSON_DESCRIPTION_LENGTH,
    type: 'string',
  })
  @IsOptional()
  @IsString()
  @MaxLength(MAX_LESSON_DESCRIPTION_LENGTH)
  description?: string

  @ApiPropertyOptional({ description: 'ID du type de leçon', type: 'string' })
  @IsOptional()
  @IsUUID('4')
  typeId?: string

  @ApiPropertyOptional({
    description: 'Durée en minutes',
    minimum: MIN_LESSON_DURATION,
    maximum: MAX_LESSON_DURATION,
    type: Number,
  })
  @IsOptional()
  @Transform(toNumber)
  @IsNumber()
  @Min(MIN_LESSON_DURATION)
  @Max(MAX_LESSON_DURATION)
  duration?: number

  @ApiPropertyOptional({ description: 'ID du chapitre parent', type: 'string' })
  @IsOptional()
  @IsUUID('4')
  chapterId?: string

  @ApiPropertyOptional({ description: 'ID du statut', type: 'string' })
  @IsOptional()
  @IsUUID('4')
  statusId?: string

  @ApiPropertyOptional({ description: 'Ordre dans le chapitre', type: Number })
  @IsOptional()
  @Transform(toNumber)
  @IsNumber()
  @Min(1)
  orderInChapter?: number

  @ApiPropertyOptional({
    description: 'État de la leçon',
    enum: PedagogicContentState,
  })
  @IsOptional()
  @IsEnum(PedagogicContentState)
  state?: PedagogicContentState

  @ApiPropertyOptional({
    description: 'Visibilité de la leçon',
    enum: ContentVisibility,
  })
  @IsOptional()
  @IsEnum(ContentVisibility)
  visibility?: ContentVisibility

  @ApiPropertyOptional({
    description: 'ID de la matière externe',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  subjectExternalId?: string

  @ApiPropertyOptional({
    description: 'ID du niveau externe',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  levelExternalId?: string

  @ApiPropertyOptional({
    description: 'IDs des concepts du programme à associer à la leçon',
    type: [String],
    example: ['550e8400-e29b-41d4-a716-446655440000'],
  })
  @IsOptional()
  @IsArray()
  @IsUUID('4', { each: true })
  programConceptIds?: string[]
}
